// @flow
import * as React from 'react';
import classNames from 'classnames';
import DropDownMenu from '@liveauctioneers/caterwaul-components/lib/DropDownMenu/DropDownMenu';
import { faHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import NotificationsContainer from '../Notifications/NotificationsContainer';
import PaddleIconSvg from './PaddleIconSvg.js';
import styles from './LoggedInMenu.module.scss';

type Props = {
    baseUrl: string,
    logOutBidder: Function,
    mobile: string,
    parent: any,
    pathname: string,
    userFirstName: string,
    whiteLabel: boolean,
    windowWidth: number,
};

const LoggedInMenu = (props: Props) => {
    const {
        baseUrl = '',
        logOutBidder,
        mobile: mobileDevice,
        parent,
        pathname,
        userFirstName = '',
        whiteLabel,
        windowWidth,
    } = props;

    const mobile = windowWidth <= 768;
    const links = [];

    const useNewMessaging = baseUrl.includes('preprod') || baseUrl.includes('stage');

    if (mobile) {
        links.push(
            <Link key="my-bids" route to="/dashboard/my-bids">
                <FormattedMessage id="userMenu.my_bids" />
            </Link>
        );
    }

    links.push(
        <Link key="my-auctions" route to="/dashboard/my-auctions">
            <FormattedMessage id="my_auctions" />
        </Link>
    );
    links.push(
        <Link key="won-items" route to="/dashboard/won-items">
            <FormattedMessage id="won_items" />
        </Link>
    );
    links.push(
        <Link key="messages" route to={useNewMessaging ? '/dashboard/new-messages' : '/dashboard/messages'}>
            <FormattedMessage id="messages" />
        </Link>
    );
    if (!whiteLabel) {
        links.push(
            <Link key="search-and-alerts" route to="/dashboard/search-and-alerts/">
                <FormattedMessage id="saved_searches_and_alerts" />
            </Link>
        );
    }
    if (!whiteLabel) {
        links.push(
            <Link key="followed-sellers" route to="/dashboard/followed-auctioneers">
                <FormattedMessage id="followed_auctioneers" />
            </Link>
        );
    }
    links.push(
        <Link key="profile" route to="/dashboard/profile">
            <FormattedMessage id="account_settings" />
        </Link>
    );
    links.push(
        <Link key="log-out" className={styles.logOut} onClick={logOutBidder}>
            <FormattedMessage id="log_out" />
        </Link>
    );

    const title = (
        <div className={styles.menuItem}>
            <FontAwesomeIcon icon={faUser} className={styles.menuIcon} />
            <span className={styles.menuText}>
                {userFirstName.length > 0 && userFirstName.length < 9 ? (
                    <FormattedMessage id="userMenu.greeting" values={{ userFirstName }} />
                ) : (
                    <FormattedMessage id="userMenu.my_account" />
                )}
            </span>
        </div>
    );

    return (
        <div className={styles.loggedIn}>
            {!whiteLabel && <NotificationsContainer mobile={mobile} parent={parent} pathname={pathname} />}
            <div className={styles.menuWrapper}>
                <Link key="saved-items" route to="/dashboard/saved-items">
                    <div className={styles.menuItem}>
                        <FontAwesomeIcon icon={faHeart} className={styles.menuIcon} />
                        <span className={styles.menuText}>
                            <FormattedMessage id="userMenu.favorites" />
                        </span>
                    </div>
                </Link>
            </div>
            {!mobile && (
                <div className={styles.menuWrapper}>
                    <Link key="my-bids" className={styles.myBidsHover} route to="/dashboard/my-bids">
                        <div className={styles.menuItem}>
                            <PaddleIconSvg className={styles.paddleIcon} />
                            <span className={styles.menuText}>
                                <FormattedMessage id="userMenu.my_bids" />
                            </span>
                        </div>
                    </Link>
                </div>
            )}
            <DropDownMenu
                links={links}
                mobile={mobileDevice}
                dropdownClass={classNames(styles.menuWrapper, styles.myAccountWrapper)}
                parent={parent}
                placement="bottom"
                popoverClass={styles.popover}
                title={title}
                titleClass={styles.myAccountTitle}
            />
        </div>
    );
};

export default React.memo<Props>(LoggedInMenu, isEqual);
